/** @typedef {'light' | 'dark' | 'system'} AppearanceMode */
/** @typedef {'light' | 'dark'} ResolvedAppearanceMode */

export const APPEARANCE_STORAGE_KEY = 'do-compute-appearance'

/** @returns {AppearanceMode} */
export function getStoredAppearanceMode() {
  if (typeof window === 'undefined') return 'dark'
  try {
    const stored = window.localStorage.getItem(APPEARANCE_STORAGE_KEY)
    if (stored === 'light' || stored === 'dark' || stored === 'system') return stored
  } catch {
    /* ignore quota / privacy errors */
  }
  return 'dark'
}

/** @param {AppearanceMode} mode */
export function resolveAppearanceMode(mode) {
  if (mode === 'system') {
    if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark'
    }
    return 'light'
  }
  return mode === 'dark' ? 'dark' : 'light'
}

/** @param {ResolvedAppearanceMode} mode */
export function isValidAppearanceMode(mode) {
  return mode === 'light' || mode === 'dark' || mode === 'system'
}

/** @param {ResolvedAppearanceMode} resolvedMode */
export function applyAppearanceToDocument(resolvedMode) {
  if (typeof document === 'undefined') return
  document.documentElement.dataset.theme = resolvedMode
  document.documentElement.style.colorScheme = resolvedMode
}

/** Inline bootstrap — keep logic aligned with `resolveAppearanceMode` (spec default dark). */
export const APPEARANCE_INIT_SCRIPT = `(function(){try{var k='${APPEARANCE_STORAGE_KEY}';var m=localStorage.getItem(k)||'dark';var r=m==='dark'?'dark':m==='system'&&window.matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light';document.documentElement.dataset.theme=r;document.documentElement.style.colorScheme=r;}catch(e){}})();`
